import { useParams } from "react-router-dom";
import { useState } from "react";
import emailjs from "emailjs-com";
import "./CourseBuy.css";

function CourseBuy() {
  const { title, offerPrice } = useParams();
  const [screenshot, setScreenshot] = useState(null);
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    method: "",
    reference: "",
  });
  const [loading, setLoading] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Convert + compress file to Base64 under 50KB
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Resize image (max width 600px)
          const MAX_WIDTH = 600;
          const scaleSize = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scaleSize;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Compress to JPEG (quality 0.6)
          const compressed = canvas.toDataURL("image/jpeg", 0.6);
          setScreenshot(compressed);
        };
      };
      reader.readAsDataURL(file);
    }
  };

  // Send email
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const templateParams = {
      course_title: decodeURIComponent(title),
      amount: decodeURIComponent(offerPrice),
      full_name: formData.fullName,
      mobile: formData.mobile,
      method: formData.method,
      reference: formData.reference,
      screenshot: screenshot, // compressed base64 string
    };

    emailjs
      .send(
        "service_lv2cgr7", // ✅ Your EmailJS Service ID
        "template_7qsnvw1", // ✅ Your Template ID
        templateParams,
        "IBadFU7RAb1dIjvNz" // ✅ Your Public Key
      )
      .then(
        () => {
          alert("✅ Payment details sent successfully! We will contact you soon.");
          setLoading(false);
          setFormData({
            fullName: "",
            mobile: "",
            method: "",
            reference: "",
          });
          setScreenshot(null);
        },
        (error) => {
          console.error("❌ EmailJS Error:", error.text || error);
          alert("❌ Failed to send. Try again.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="buy-page">
      <div className="buy-card">
        <h1>
          Buy Course:{" "}
          <span className="highlight">{decodeURIComponent(title)}</span>
        </h1>
        <p className="subtext">
          Learn and grow at your own pace. Limited time offer!
        </p>

        {/* Payment Section */}
        <section className="payment-section">
          <h2>Step 1: Make Your Payment</h2>
          <div className="payment-methods">
            <div className="qr-box">
              <img
                src="/assets/UPI_Jyotish.jpeg"
                alt="Scan to Pay"
                className="qr"
              />
              <p>Scan with any UPI app</p>
            </div>
            <div className="upi-details">
              <p><strong>UPI ID:</strong> jyotishkarmaa@okaxis</p>
              <p><strong>Bank:</strong> AXIS Bank</p>
              <p><strong>Account No:</strong> 923010048103133</p>
              <p><strong>IFSC Code:</strong> UTIB0001159</p>
              <p><strong>SWIFT Code:</strong> AXISIN88053</p>
              <p><strong>Amount:</strong> ₹{decodeURIComponent(offerPrice)}</p>
            </div>
          </div>
        </section>

        {/* Form Section */}
        <section className="form-section">
          <h2>Step 2: Submit Your Payment Details</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Your Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <select
              name="method"
              value={formData.method}
              onChange={handleChange}
              required
            >
              <option value="">Select Payment Method</option>
              <option value="upi">UPI</option>
              <option value="bank">Bank Transfer</option>
            </select>
            <input
              type="text"
              name="reference"
              placeholder="UTR / Reference Number"
              value={formData.reference}
              onChange={handleChange}
              required
            />
            <label style={{ marginTop: "10px" }}>Upload Screenshot:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              required
            />
            {screenshot && (
              <div className="preview-box">
                <p><strong>Preview:</strong></p>
                <img
                  src={screenshot}
                  alt="Screenshot Preview"
                  style={{ width: "200px", marginTop: "10px" }}
                />
              </div>
            )}
            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Submit Payment Info"}
            </button>
          </form>
        </section>

        <div className="help">
          <p>
            Need help? <a href="tel:+918840155356">Call us</a> or{" "}
            <a href="https://wa.me/918840155356" target="_blank" rel="noreferrer">
              Chat on WhatsApp
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CourseBuy;
